import type * as THREE from 'three';
import { createCanvas, canvasTexture } from './canvas';

let cached: THREE.CanvasTexture | null = null;

export function getTrailSprite(): THREE.CanvasTexture {
  if (cached) return cached;
  const size = 128;
  const { canvas, ctx } = createCanvas(size, size);
  const cx = size / 2;
  const cy = size / 2;

  const gradient = ctx.createRadialGradient(cx, cy, 0, cx, cy, size * 0.5);
  gradient.addColorStop(0.0, 'rgba(255,255,255,1)');
  gradient.addColorStop(0.18, 'rgba(255,255,255,0.85)');
  gradient.addColorStop(0.42, 'rgba(255,255,255,0.42)');
  gradient.addColorStop(0.72, 'rgba(255,255,255,0.12)');
  gradient.addColorStop(1.0, 'rgba(255,255,255,0)');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, size, size);

  cached = canvasTexture(canvas);
  return cached;
}
